<template>
  <bpb-form-communicator v-model="internalValue" :name="name">
    <div class="input-checkbox">
      <input
        :id="id"
        type="checkbox"
        class="input-checkbox__input"
        :required="required"
        :aria-required="required"
        :disabled="disabled"
        :aria-disabled="disabled"
        :checked="internalValue === 'true'"
        v-bind="
          $makeFieldUpdateBinding({
            classListObject: {
              'input-checkbox__input--is-disabled': disabled,
            },
          })
        "
        @change="change"
      />
      <label :for="id" class="input-checkbox__label">
        <!-- because checkbox itself is rendered as pseudo element
         in a flex context -->
        <span>
          <slot />
        </span>
      </label>
      <bpb-form-error-portal :name="name" />
    </div>
  </bpb-form-communicator>
</template>

<script>
import {
  InputIdProvider,
  FieldUpdateProvider,
} from '@components/molecules/form/form.mixin.js';

export default {
  mixins: [
    InputIdProvider,
    FieldUpdateProvider({ baseClass: 'input-checkbox__input' }),
  ],

  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalValue: this.value + '',
      uuid: this.$uuid.v1(),
      hasStoredError: false,
    };
  },

  methods: {
    change(event) {
      const value = event.target.checked + '';
      this.internalValue = value;
      this.$emit('change', value);
    },
  },
};
</script>
